import React, { useMemo } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';

const SintraThankYou = () => {
  const location = useLocation();
  const [searchParams] = useSearchParams();

  const bookingResponse = location.state?.bookingResponse || null;
  const reservationData = location.state?.reservationData || null;
  const paymentStatus = searchParams.get('status');
  const basketId = searchParams.get('basket_id');

  const selectedRoom = reservationData?.selectedRooms?.[0] || null;

  const bookingRef = bookingResponse?.reservationNumber || basketId || searchParams.get('bookingRef') || 'TSH-2205';
  const total = bookingResponse?.totalAmount || reservationData?.totals?.total || searchParams.get('total') || '21735';
  const voucher = reservationData?.voucher || null;

  const summary = useMemo(() => {
    const checkIn = bookingResponse?.checkInDate || reservationData?.checkIn || null;
    const checkOut = bookingResponse?.checkOutDate || reservationData?.checkOut || null;
    const inDate = checkIn ? new Date(checkIn) : null;
    const outDate = checkOut ? new Date(checkOut) : null;
    const validIn = inDate && !Number.isNaN(inDate.getTime()) ? inDate : null;
    const validOut = outDate && !Number.isNaN(outDate.getTime()) ? outDate : null;
    const nights = bookingResponse?.numberOfNights || reservationData?.totals?.nights || (validIn && validOut ? Math.max(1, Math.round((validOut - validIn) / (1000 * 60 * 60 * 24))) : 1);

    const subtotal = Number(bookingResponse?.subtotal ?? reservationData?.totals?.subtotal ?? 0);
    const taxes = Number(bookingResponse?.taxAmount ?? reservationData?.totals?.tax ?? 0);
    const discount = Number(bookingResponse?.discountAmount ?? reservationData?.totals?.discount ?? 0);
    const totalPaid = Number(bookingResponse?.totalPaid ?? reservationData?.totals?.advanceAmount ?? 0);
    const totalAmount = Number(bookingResponse?.totalAmount ?? reservationData?.totals?.total ?? total);
    const balance = totalAmount - totalPaid;
    const paymentStatus = bookingResponse?.paymentStatus || (paymentStatus === 'failed' ? 'Failed' : 'Confirmed');
    const paymentMethod = location.state?.paymentMethod || (totalPaid >= totalAmount ? 'online-payment' : 'pay-at-hotel');

    return {
      guestName: bookingResponse?.guestName || `${reservationData?.guestInfo?.firstName || ''} ${reservationData?.guestInfo?.lastName || ''}`.trim() || 'Guest',
      phone: bookingResponse?.guestPhone || reservationData?.guestInfo?.phone || 'N/A',
      email: bookingResponse?.guestEmail || reservationData?.guestInfo?.email || 'N/A',
      checkIn: validIn ? validIn.toLocaleDateString('en-US') : 'N/A',
      checkOut: validOut ? validOut.toLocaleDateString('en-US') : 'N/A',
      nights,
      bookingDate: (bookingResponse?.createdAt ? new Date(bookingResponse.createdAt) : new Date()).toLocaleDateString('en-US'),
      roomName: selectedRoom?.name || bookingResponse?.rooms?.[0]?.roomTypeName || 'Executive Room',
      roomImage: selectedRoom?.image || '/img/rooms/60.jpg',
      guests: `${bookingResponse?.numberOfAdults ?? reservationData?.adults ?? 1} Adults, ${bookingResponse?.numberOfChildren ?? reservationData?.children ?? 0} Children`,
      subtotal,
      taxes,
      discount,
      totalAmount,
      totalPaid,
      balance,
      paymentLabel: paymentStatus === 'Failed' || paymentStatus === 'failed' ? 'Payment Failed / Pending' : (paymentStatus === 'Paid' || paymentStatus === 'paid' ? 'Paid' : paymentStatus),
      paymentMethodLabel: paymentMethod === 'online-payment' ? 'Online Payment (PayFast)' : 'Pay at Hotel (25% Deposit)',
      arrivalTime: reservationData?.guestInfo?.arrival || bookingResponse?.checkinNotes?.replace('Arrival Time: ', '') || ''
    };
  }, [bookingResponse, reservationData, selectedRoom, paymentStatus, total, location.state?.paymentMethod]);

  return (
    <>
      <div className="banner-header section-padding valign bg-img" data-overlay-dark="4" data-background="/img/slider/sub.png" style={{ backgroundImage: 'url(/img/slider/sub.png)', backgroundSize: 'cover', backgroundPosition: 'center center', backgroundRepeat: 'no-repeat' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12 caption mt-90 text-left">
              <span>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
                <i className="star-rating"></i>
              </span>
              <h1>Book Luxury Hotel in Islamabad</h1>
            </div>
          </div>
        </div>
      </div>

      <section className="section-padding">
        <div className="container">
          <div className="row">
            <div className="col-md-12 text-center">
              <h1 style={{ color: '#2c5aa0', fontSize: '48px', marginBottom: '30px' }}>
                {paymentStatus === 'failed' ? 'Your reservation is created, but payment is pending.' : 'Thank you for your Reservation!'}
              </h1>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6">
              <img src={summary.roomImage} alt={summary.roomName} style={{ width: '100%', borderRadius: '8px' }} />
              <div style={{ 
                backgroundColor: '#2c5aa0',
                color: 'white',
                padding: '20px',
                marginTop: '-50px',
                position: 'relative',
                borderRadius: '8px',
                textAlign: 'center'
              }}>
                <h3 style={{ color: 'white', margin: 0 }}>{summary.roomName}</h3>
                <p style={{ color: 'white', margin: '5px 0 0 0' }}>{summary.guests}</p>
              </div>
            </div>

            <div className="col-md-6">
              <div style={{ backgroundColor: '#f8f9fa', padding: '30px', borderRadius: '8px' }}>
                <h2 style={{ color: '#2c5aa0', marginBottom: '20px' }}>Receipt Summary</h2>
                
                <table style={{ width: '100%', marginBottom: '20px' }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Guest Name</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.guestName}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Phone</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.phone}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Check-In</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.checkIn}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Check-Out</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.checkOut}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>No. Of Nights</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.nights}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Booking Date</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.bookingDate}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Booking Ref</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right', fontWeight: 'bold', color: '#2c5aa0' }}>{bookingRef}</td>
                    </tr>
                    {summary.arrivalTime ? (
                      <tr>
                        <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Arrival Time</td>
                        <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.arrivalTime}</td>
                      </tr>
                    ) : null}
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Payment Method</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.paymentMethodLabel}</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd' }}>Payment Status</td>
                      <td style={{ padding: '10px 0', borderBottom: '1px solid #ddd', textAlign: 'right' }}>{summary.paymentLabel}</td>
                    </tr>
                  </tbody>
                </table>

                <h3 style={{ marginTop: '30px', marginBottom: '15px' }}>Charges</h3>
                <table style={{ width: '100%', marginBottom: '20px' }}>
                  <tbody>
                    <tr>
                      <td style={{ padding: '5px 0' }}>Subtotal</td>
                      <td style={{ textAlign: 'right' }}>{Math.round(summary.subtotal)} PKR</td>
                    </tr>
                    <tr>
                      <td style={{ padding: '5px 0' }}>Taxes</td>
                      <td style={{ textAlign: 'right' }}>{Math.round(summary.taxes)} PKR</td>
                    </tr>
                    {summary.discount > 0 ? (
                      <tr>
                        <td style={{ padding: '5px 0', color: '#16a34a' }}>Discount (Voucher)</td>
                        <td style={{ textAlign: 'right', color: '#16a34a' }}>- {Math.round(summary.discount)} PKR</td>
                      </tr>
                    ) : null}
                    {summary.totalPaid > 0 ? (
                      <tr>
                        <td style={{ padding: '5px 0' }}>Amount Paid</td>
                        <td style={{ textAlign: 'right' }}>{Math.round(summary.totalPaid)} PKR</td>
                      </tr>
                    ) : null}
                  </tbody>
                </table>

                <div style={{ 
                  backgroundColor: '#2c5aa0', 
                  color: 'white', 
                  padding: '20px', 
                  borderRadius: '8px',
                  marginTop: '20px'
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '24px', fontWeight: 'bold' }}>
                    <span>Total</span>
                    <span>{Math.round(summary.totalAmount)} PKR</span>
                  </div>
                  {summary.balance > 0 ? (
                    <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: '14px', marginTop: '8px', fontWeight: 'normal' }}>
                      <span>Balance Due at Hotel</span>
                      <span>{Math.round(summary.balance)} PKR</span>
                    </div>
                  ) : null}
                </div>
              </div>

              <div style={{ 
                backgroundColor: '#fff3cd', 
                border: '1px solid #ffc107',
                padding: '20px', 
                borderRadius: '8px',
                marginTop: '20px'
              }}>
                <h4 style={{ color: '#856404', marginBottom: '15px' }}>Important Notes</h4>
                <ol style={{ paddingLeft: '20px', color: '#856404' }}>
                  <li>Party and loud gathering are not allowed</li>
                  <li>Check-in time is 2 PM, guest before 2PM will be entertained in case of room availability.</li>
                  <li>Check-out time is 12(Noon).Guest will be charged fee after this time.</li>
                  <li>Any damage to the property will be charged by the guest.</li>
                </ol>
                <p style={{ marginTop: '15px', color: '#856404' }}>
                  Please contact our customer care team 24/7 at <strong>(051) 8736313</strong>
                </p>
                <p style={{ fontStyle: 'italic', color: '#856404' }}>
                  Thanks for choosing Sintra, we wish you a pleasant stay
                </p>
              </div>

              <div style={{ textAlign: 'center', marginTop: '30px' }}>
                <button 
                  onClick={() => window.print()}
                  style={{
                    backgroundColor: 'white',
                    border: '2px solid #2c5aa0',
                    color: '#2c5aa0',
                    padding: '15px 40px',
                    fontSize: '16px',
                    fontWeight: 'bold',
                    borderRadius: '8px',
                    cursor: 'pointer'
                  }}
                >
                  🖨️ Print
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SintraThankYou;
